import { render, staticRenderFns } from "./Act.vue?vue&type=template&id=03c91d98&scoped=true&"
import script from "./Act.vue?vue&type=script&lang=js&"
export * from "./Act.vue?vue&type=script&lang=js&"
import style0 from "./Act.vue?vue&type=style&index=0&id=03c91d98&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c91d98",
  null
  
)

export default component.exports